module.exports = __webpack_public_path__ + "static/img/resume-left-right-projects.43baddb.png";